

export const LIST_CANDIDAT_ID = [1, 8, 13, 18, 7, 11, 26, 39]